import {useCallback, useContext, useRef} from "react";

// IMPORTS
import {AuthContext} from "./AuthContext";
import {TitleComponent} from "./TitleReportComponent";
import {TYPE_THEME, TYPE_THEME_AG_GRID} from "../Constants/Const";

// MUI
import {Grid, Paper, Tooltip} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';

// AG GRID
import {AgGridReact} from "ag-grid-react";
import 'ag-grid-community/styles/ag-theme-balham.css';

export function TableComponent({titleTable=null, columnsTable=null,
                                   rowsTable=null, handlingDoubleClick=null }){

    const {theme} = useContext(AuthContext);
    const gridTableRef = useRef();

    const onBtnExport = useCallback(() => {
        gridTableRef.current.api.exportDataAsCsv();
    }, []);

    return(
        <Paper elevation={12}>

            <Grid container>
                <Grid item xs={11} style={{backgroundColor: theme.MUI === TYPE_THEME.light? "rgba(240, 240, 240, 0.8)":null}}>

                    <TitleComponent title={titleTable} />

                </Grid>
                <Grid item container xs={1} style={{backgroundColor: theme.MUI === TYPE_THEME.light? "rgba(240, 240, 240, 0.8)":null}}
                      direction="row"
                      justifyContent="center"
                      alignItems="center">
                    <Tooltip title={"Descargar tabla"}>

                        <IconButton color="success" onClick={onBtnExport}>
                            <SimCardDownloadIcon/>
                        </IconButton>

                    </Tooltip>
                </Grid>
            </Grid>


            <div className={theme.MUI === TYPE_THEME.light? TYPE_THEME_AG_GRID.light:TYPE_THEME_AG_GRID.dark} style={{ height: 350, width: '100%' }}>
                <AgGridReact
                    ref={gridTableRef}
                    columnDefs={columnsTable}
                    rowData={rowsTable}
                    onRowDoubleClicked={handlingDoubleClick}
                />
            </div>

        </Paper>
    );
}